export enum Types {
  Login = 'LOGIN',
  Logout = 'LOGOUT',
  SetUser = 'SET_USER',
  Register = 'REGISTER',
  Initial = 'INITIALIZE',
}

export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export enum MainUserKeysEnum {
  CUI = 'cui',
  TVA = 'has_vat',
  ZIP = 'postal_code',
  COMPANY = 'company',
  ADDRESS = 'address',
  COUNTRY = 'country_city',
  VENIT = 'has_income_tax',
  PROFIT = 'has_profit_tax',
  SALARIATI = 'has_employees',
  ADMINISTRATORS = 'administrators',
  EXPIRATION = 'company_office_expiration',
}

export enum OtherUserKeysEnum {
  NAME = 'name',
  EMAIL = 'email',
  PHONE = 'phone',
  MEMENTO = 'memento_op',
  SUBSCRIBED = 'is_subscribed',
}

export const UserKeysEnum = {
  ...MainUserKeysEnum,
  ...OtherUserKeysEnum,
};

export type UserKeysType = MainUserKeysEnum | OtherUserKeysEnum;

export type UserType = {
  [UserKeysEnum.NAME]: string;
  [UserKeysEnum.EMAIL]: string;
  [UserKeysEnum.TVA]: boolean;
  [UserKeysEnum.CUI]: string | null;
  [UserKeysEnum.MEMENTO]: boolean;
  [UserKeysEnum.PHONE]: string | null;
  [UserKeysEnum.ADDRESS]: string | null;
  [UserKeysEnum.COMPANY]: string | null;
  [UserKeysEnum.SUBSCRIBED]: boolean;
  [UserKeysEnum.SALARIATI]: boolean;
  [UserKeysEnum.PROFIT]: boolean;
  [UserKeysEnum.VENIT]: boolean;
  [UserKeysEnum.ZIP]: string | null;
  [UserKeysEnum.EXPIRATION]: string;
  [UserKeysEnum.COUNTRY]: string | null;
  [UserKeysEnum.ADMINISTRATORS]: { id: string; name: string }[];
};

export type ProfileResponseType = {
  data: UserType;
};

export type SetUserType = {
  [key in UserKeysType]?: any;
};

export type AuthUser = null | UserType;

export type AuthState = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  isSubscribed: boolean;
  user: AuthUser;
};

export enum AuthRegisterParamsEnum {
  NAME = 'name',
  EMAIL = 'email',
  PASSWORD = 'password',
}

export type AuthRegisterParamsType = Record<AuthRegisterParamsEnum, string>;

export type AuthContextType = {
  isAuthenticated: boolean;
  isInitialized: boolean;
  isSubscribed: boolean;
  user: AuthUser;
  setUser: (user: SetUserType) => void;
  login: (email: string, password: string) => Promise<void>;
  forgotPassword: (email: string) => Promise<void>;
  resetPassword: (params: {token: string, password: string, email: string}) => Promise<void>;
  register: (params: AuthRegisterParamsType) => Promise<void>;
  logout: () => Promise<void>;
};

export type JWTAuthPayload = {
  [Types.Initial]: {
    user: AuthUser;
    isSubscribed: boolean;
    isAuthenticated: boolean;
  };
  [Types.Login]: {
    user: AuthUser;
    isSubscribed: boolean;
  };
  [Types.Logout]: undefined;
  [Types.Register]: {
    user: AuthUser;
    isSubscribed: boolean;
  };
  [Types.SetUser]: SetUserType;
};

export type JWTActions =
  ActionMap<JWTAuthPayload>[keyof ActionMap<JWTAuthPayload>];
